import React, { Component } from 'react'
import { Dropdown, ButtonGroup, Button } from 'react-bootstrap';

class EmpresasItemActions extends Component {

  render() {

    return (
      <Dropdown as={ ButtonGroup } alignRight={ true }>
        <Button variant="info">Acciones</Button>

        <Dropdown.Toggle split variant="info" id="dropdown-split-basic" />

        <Dropdown.Menu>
          <Dropdown.Item href="#/action-1">Action 1</Dropdown.Item>
          <Dropdown.Item href="#/action-2">Action 2</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}

export default EmpresasItemActions;